export default {
  menus: {
	  backend:{
		  basicManager:"Manajemen Basic",
		  businessManager:"Manajemen Penjualan",
		  cloudManager:"Manajemen 金蝶K3",
		  factoryManager:"Ikatan Dengan Pabrik",
		  assetManager:"行政中心",
		  reportManager:"报表管理"
	  },
	  backendModule:{
		  basicSysModule:"Sistem",
		  basicHrModule:"HRD",
		  basicSalaryModule:"Gaji",
		  businessBasicModule:"Basic",
          systemBasicModule:"系统服务",
          operatorsModule:"operators",
		  businessWorkModule:"Bisnis",
		  businessPlanningModule:"Planning",
		  businessReportModule:"Laporan",
		  cloudReportModule:"Laporan",
		  cloudInputModule:"Nota Input",
		  cloudSysModule:"sistem",
		  factoryBasicModule:"Basic",
		  businessFutureModule:"订货",
		  businessLogisticsModule:"物流仓储",
          businessProductModule:"商品中心",
		  businessImeModule:"串码",
		  businessCustomerModule:"渠道中心",
		  businessPerformanceModule:"考核激励",
		  businessAdvertisingModule:"终端企划",
		  businessAftersalesModule:"售后",
		  businessTrainingModule:"培训",
		  businessToolModule:"工厂对接",
		  basicDutyModule:"勤务服务",
		  basicEmployeeModule:"员工服务",
		  basicAccountModule:"账户服务",
		  basicRecruitModule:"招聘服务",
		  supportBasicModule:"业务基础",
		  assetAssetModule:"资产模块",
		  assetMessageModule:"消息中心",
          assetServiceModule: "后勤服务",
		  cloudModule:"金蝶管理",
		  reportModule:"报表管理",
          hrCooperationModule:"协同服务",
          businessDistributionModule: "分货",
	  },
    menuCategory:{
      hrCategory:"Manajemen SDM",
      sysCategory:"Pengaturan Sistem",
      saleCategory:"Manajemen Penjualan",
      apiCategory:"Interface Eksternal",
      menusCategory:"Menu",
      officeCategory:"Struktur Organisasi",
      dictCategory:"Kamus",
      permissionCategory:"Otoritas",
      fileCategory:"File",
      dutyCategory:"Manajemen duty",
      workStreamCategory:"Alur Kerja",
      taskCenterCategory:"Pusat Persetujuan File",
      accountAboutCategory:"Karyawan",
      salaryCategory:"Manajemen Upah",
      productImeCategory:"String Kode Barang",
      goodsOrderCategory:"Manajemen Pemesanan barang",
      baseCategory:"Informasi Dasar",
      adCategory:"Material Iklan",
      customerCategory:"Pusat Service Center",
      afterSaleCategory:"Manajemen Service Center",
      saleReportCategory:"Laporan Penjualan",
      k3CloudCategory:"K3Cloud",
      b2bCategory:"Mall Online",
      oppoDataCategory:"Data OPPO",
      dataManagerCategory:"Manajemen Data",
      vivoDataCategory:"Data vivo",
      djDataCategory:"Data E-Education",
      taskPolicyCategory:"Kebijakan Misi",
      commissionCategory:"Komisi Standar",
      reportCategory:"Pusat Laporan",
      cloudBatchBillCategory:"Batch Input",
      cloudReportCategory:"Laporan Finance",
      cloudSysCategory:"Setting Sistem"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/table_data_id.js